import actions from 'redux-auto'
import i18n from 'i18next'
import {groupBy} from 'lodash'
import Api from '#services/api'

export const DEFAULT_RESULT_COUNT = 50

export function pending(state) {
  return {
    ...state,
  }
}

export function fulfilled(state, payload, result) {
  if (!result) {
    return state
  }
  const grouped = groupBy(result, 'hasBeenRead')

  return {
    ...state,
    all: result || [],
    unread: grouped.false || [],
    read: grouped.true || [],
  }
}

export function rejected(state) {
  return {
    ...state,
  }
}

export async function action(payload) {
  const resultCount = payload.resultCount || DEFAULT_RESULT_COUNT
  try {
    return await Api.markNotificationAsUnread(payload.notificationId, resultCount)
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
